"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiShell = require("@concur/nui-shell");

require("core-js/stable");

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _configureStore = _interopRequireDefault(require("./configureStore"));

var _routes = _interopRequireDefault(require("./routes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global __DEVTOOLS__, window */
var store = (0, _configureStore.default)(window.__INITIAL_STATE__); // eslint-disable-line no-underscore-dangle

var DevTools = function DevTools() {
  return null;
};

if (process.env.NODE_ENV !== 'production') {
  DevTools = require('./DevTools').default;
}

var Root = function Root() {
  return _react.default.createElement(_nuiShell.NuiClient, {
    store: store,
    routes: _routes.default
  }, typeof __DEVTOOLS__ !== 'undefined' && __DEVTOOLS__ && _react.default.createElement(DevTools, null));
};

var _default = Root;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/app/Root.js
// module id = 88
// module chunks = 0